export default __webpack_public_path__ + "static/IMDA_SME_Medium-d9998756c71f7dda9a81d318958a1d5c.webp";